import type { DeviceManifest } from '@rapoo/device-sdk'
import {
  itineraryDisabled,
  keyFeaturesDisabled,
  keyboardMacro,
  keyboardPerfV700,
} from './generate/capabilityPresets'
import {
  V700IndicatorEffects,
  v700KeyboardEffects,
  V700SideLightingEffects,
} from './generate/lightingPresets'

/** Telink 键盘控制接口由设备管理器用来筛选默认通信通道。 */
const TELINK_KEYBOARD_CONTROL_FILTER = {
  usagePage: 0xff00,
  usage: 14,
  description: 'VT700 Telink 控制接口',
  type: 'default' as const,
}

// 升级接口独立于业务控制接口，避免升级数据写入普通命令通道。
const TELINK_KEYBOARD_UPDATE_FILTER = {
  usagePage: 0xffef,
  usage: 0,
  description: 'VT700 Telink 固件升级接口',
  type: 'update' as const,
}

/**
 * 为同一套 Telink 键盘协议生成型号 manifest。
 *
 * 有线 PID 在前、接收器 PID 在后，是现有键盘驱动识别连接类型的既有约定。
 */
function createTelinkKeyboardManifest(
  model: string,
  keyboardPid: number,
  receiverPid: number,
): DeviceManifest {
  return {
    channel: ['china_game', 'global'],
    model,
    mainControl: model,
    dongleModel: 'Dongle_Telink',
    type: 'keyboard',
    hardware: {
      vendorId: 0x24ae,
      productId: [keyboardPid, receiverPid],
      currentPid: keyboardPid,
      transport: 'HID',
      filters: [TELINK_KEYBOARD_CONTROL_FILTER, TELINK_KEYBOARD_UPDATE_FILTER],
    },
    driver: 'TelinkKeyboard',
    MCU: 'Telink',
    ui: {
      assetsDir: 'manifests/VT700DIY',
      colors: { series: [], current: '' },
      icon: 'Hardware-Wireframe-Keyboard',
      overview: false,
    },
    capabilities: [
      {
        type: 'lighting',
        config: {
          enable: true,
          effects: [...v700KeyboardEffects, ...V700SideLightingEffects, ...V700IndicatorEffects],
        },
      },
      itineraryDisabled,
      keyFeaturesDisabled,
      keyboardPerfV700,
      keyboardMacro,
    ],
    layout: { keys: [] },
  }
}

/** V700DIY Telink 系列的 WebHID 验证清单。 */
export const VT700_MANIFESTS = [
  createTelinkKeyboardManifest('V700diy-98', 0x4805, 0x1905),
  createTelinkKeyboardManifest('V700diy-87', 0x4806, 0x1906),
  createTelinkKeyboardManifest('V700diy-75', 0x4807, 0x1907),
  createTelinkKeyboardManifest('V700diy-98 LRV', 0x4824, 0x1924),
  createTelinkKeyboardManifest('V700diy-75 LRV', 0x6204, 0x7204),
]

export default VT700_MANIFESTS
